<template>
  <div>
    <common-Compontent :factorType="factorType" :month="month"></common-Compontent>
  </div>
</template>
<script>
import commonCompontent from './commonVue.vue';
export default {
  name: 'govtCert',
  components: {
    commonCompontent
  },
  data() {
    return {
      factorType: 'GOVT_CERT',
      month: []
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log('to', to);
    console.log('from', from);
    if (from.path === '/qspiTodo') {
      if (to.query.month) {
        next(vm => {
          vm.month.push(to.query.month)
          console.log('vm.month', vm.month);
        })
      } else {
        next()
      }
    } else {
      next()
    }
  },
  created() {

  },
  methods: {

  }
}
</script>